import { createFileRoute } from '@tanstack/react-router';
import { ExitsPage } from '@/features/exits/exits-page';
import { guardRoute } from '@/lib/route-guards';

export const Route = createFileRoute('/_app/hr/exits')({
  beforeLoad: ({ context }) => {
    guardRoute(context.auth, '/hr/exits');
  },
  component: ExitsPage,
});
